import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Heart, Menu, X, Search, Send } from 'lucide-react';
import { useCart } from '../context/CartContext';

const NAV = [
  { to: '/', label: 'Strona Główna' },
  { to: '/sklep', label: 'Sklep' },
  { to: '/o-nas', label: 'O Nas' },
  { to: '/kontakt', label: 'Kontakt' }
];

const Header = () => {
  const { cartCount, setDrawerOpen, wishlist } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const submitSearch = (e) => {
    e.preventDefault();
    if (search.trim()) navigate(`/sklep?q=${encodeURIComponent(search.trim())}`);
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-blue-100">
      <div className="bg-blue-600 text-white text-xs py-2">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          <span className="hidden sm:block">Pełna anonimowość • Wysyłka 24-48h • Kontakt przez Telegram</span>
          <span className="sm:hidden">Anonimowe zakupy</span>
          <a href="https://t.me/+9A5CpRihCfNjMzc0" target="_blank" rel="noreferrer" className="flex items-center gap-1.5 hover:underline font-semibold">
            <Send className="w-3.5 h-3.5" /> Telegram
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-3.5 flex items-center gap-6">
        <Link to="/" className="flex items-center gap-2 group flex-shrink-0">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-sky-400 flex items-center justify-center shadow-md shadow-blue-200 group-hover:scale-105 transition-transform">
            <span className="text-white font-bold text-lg">α</span>
          </div>
          <div className="leading-tight">
            <div className="text-slate-900 font-bold text-lg tracking-tight">AlphaPro</div>
            <div className="text-blue-600 text-[10px] font-semibold tracking-widest uppercase">Genetics</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1 ml-4">
          {NAV.map(n => (
            <Link key={n.to} to={n.to} className="px-3.5 py-2 text-sm font-medium text-slate-700 hover:text-blue-600 hover:bg-blue-50 rounded-full transition">
              {n.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="hidden md:flex flex-1 relative max-w-md ml-auto">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Szukaj produktów..."
            className="w-full pl-11 pr-4 py-2.5 rounded-full bg-blue-50/70 border border-blue-100 focus:bg-white focus:border-blue-400 focus:outline-none focus:ring-4 focus:ring-blue-100 transition text-sm text-slate-800 placeholder:text-slate-400"
          />
        </form>

        <div className="flex items-center gap-1 ml-auto md:ml-0">
          <Link to="/ulubione" className="relative p-2.5 rounded-full hover:bg-blue-50 transition" aria-label="Wishlist">
            <Heart className="w-5 h-5 text-slate-700" />
            {wishlist.length > 0 && <span className="absolute -top-0.5 -right-0.5 bg-blue-600 text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">{wishlist.length}</span>}
          </Link>
          <button onClick={() => setDrawerOpen(true)} className="relative p-2.5 rounded-full hover:bg-blue-50 transition" aria-label="Cart">
            <ShoppingCart className="w-5 h-5 text-slate-700" />
            {cartCount > 0 && <span className="absolute -top-0.5 -right-0.5 bg-blue-600 text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">{cartCount}</span>}
          </button>
          <button className="lg:hidden p-2.5 rounded-full hover:bg-blue-50" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-blue-100 bg-white px-4 py-3">
          <form onSubmit={submitSearch} className="relative mb-3 md:hidden">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Szukaj produktów..." className="w-full pl-11 pr-4 py-2.5 rounded-full bg-blue-50 border border-blue-100 text-sm focus:outline-none" />
          </form>
          <ul className="flex flex-col gap-1">
            {NAV.map(n => (
              <li key={n.to}><Link onClick={() => setMobileOpen(false)} to={n.to} className="block px-3 py-2 rounded-lg hover:bg-blue-50 text-sm font-medium">{n.label}</Link></li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
